import { render, staticRenderFns } from "./ArchivoPdf.vue?vue&type=template&id=0b79d12c&scoped=true&"
import script from "./ArchivoPdf.vue?vue&type=script&lang=js&"
export * from "./ArchivoPdf.vue?vue&type=script&lang=js&"
import style0 from "./ArchivoPdf.vue?vue&type=style&index=0&id=0b79d12c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b79d12c",
  null
  
)

export default component.exports